import BaseService from "@/boot/BaseService";
class RoleService extends BaseService {
  constructor() {
    super(null, "/roles");
  }
  async store(formData) {
    return await this.post("", formData);
  }
  async show(id) {
    return await this.get(`/${id}`);
  }
  async permissionsAll() {
    return await this.get("/permissions-all");
  }
  async addRolePermission(roleId, permissionId) {
    return await this.put("/permission-add", {
      role_id: roleId,
      permission_id: permissionId,
    });
  }
  async removeRolePermission(roleId, permissionId) {
    return await this.delete("/permission-remove", {
      data: {
        role_id: roleId,
        permission_id: permissionId,
      },
    });
  }
}

export default new RoleService();
